import { jsx as _jsx } from "react/jsx-runtime";
import { colors } from "@vfit/shared/themes";
import { PillContainer } from "./pill.style";
var Pill = function(param) {
    var _label = param.label, label = _label === void 0 ? "defaultLabel" : _label, _pillsColor = param.pillsColor, pillsColor = _pillsColor === void 0 ? colors.$ffffff : _pillsColor, _opacity = param.opacity, opacity = _opacity === void 0 ? 0.8 : _opacity, borderColor = param.borderColor;
    return /*#__PURE__*/ _jsx(PillContainer, {
        pillsColor: pillsColor,
        opacity: opacity,
        borderColor: borderColor,
        children: /*#__PURE__*/ _jsx("span", {
            style: {
                color: pillsColor === colors.$ffffff ? colors.$262626 : colors.$ffffff
            },
            children: label
        })
    });
};
export default Pill;
